import { Helmet } from "react-helmet-async";

/**
 * Per-page SEO tags. Only overrides what's provided; defaults from index.html stay.
 * Usage:
 *   <SEO title="Pricing · SourceDeck" description="..." path="/pricing" />
 */
export default function SEO({ title, description, path, image, noindex }) {
  const url = path ? `https://sourcedeck.tech${path}` : "https://sourcedeck.tech/";
  const ogImage = image || "https://sourcedeck.tech/og-image.png";
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
